import axiosInstance from "../instance/AxiosInstance";

// API call to change the password
const changePasswordApi = async (payload) => {
 
  try {
    const response = await axiosInstance.put("/auth/changepassword", payload);
 
    // Assuming the response data is in the format you expect
    return response.data;//here data use because response come inside data

  } catch (error) {
    // Handle error (axios automatically throws errors for 4xx and 5xx status codes)
    throw new Error(error.response?.data?.message || "Failed to change password");
  }
};

export default changePasswordApi;
